var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDifferentiation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54199 1.16666C4.89765 1.16666 4.37533 1.689 4.37533 2.33332V4.37499H2.33366C1.68933 4.37499 1.16699 4.89731 1.16699 5.54166V11.6667C1.16699 12.311 1.68933 12.8333 2.33366 12.8333H8.45866C9.103 12.8333 9.62533 12.311 9.62533 11.6667V9.62499H11.667C12.3113 9.62499 12.8337 9.10266 12.8337 8.45832V2.33332C12.8337 1.689 12.3113 1.16666 11.667 1.16666H5.54199ZM8.45866 8.45832V5.54166H5.54199V8.45832H8.45866ZM5.54199 2.33332H11.667V8.45832H9.62533V5.54166C9.62533 4.89732 9.103 4.37499 8.45866 4.37499H5.54199V2.33332ZM2.33366 5.54166H4.37533V8.45832C4.37533 9.10266 4.89765 9.62499 5.54199 9.62499H8.45866V11.6667H2.33366V5.54166Z",
    fill: "#142A31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferentiation);
export default __webpack_public_path__ + "static/media/differentiation.7ab433a061b2a3631e3e303778fc763d.svg";
export { ForwardRef as ReactComponent };